<script lang="ts">
  export let position: 'top' | 'middle' | 'bottom' = 'top';
  
  // Replace with your actual AdSense publisher ID when ready
  const adClientId = 'ca-pub-XXXXXXXXXXXXXXXX';
</script>

<div class="adsense-banner" data-position={position}>
  <!-- Google AdSense Banner Ad -->
  <!-- 
  <ins class="adsbygoogle"
       style="display:block"
       data-ad-client={adClientId}
       data-ad-slot="XXXXXXXXXX"
       data-ad-format="auto"
       data-full-width-responsive="true"></ins>
  <script>
    (adsbygoogle = window.adsbygoogle || []).push({});
  </script>
  -->
  
  <!-- Placeholder for development -->
  <div class="ad-placeholder">
    <span class="ad-label">Advertisement</span>
    <p>Google AdSense - {position.toUpperCase()} Banner</p>
    <small>728x90 or Responsive</small>
  </div>
</div>

<style>
  .adsense-banner {
    margin: 30px auto;
    text-align: center;
    max-width: 100%;
    overflow: hidden;
  }
  
  .ad-placeholder {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    border: 2px dashed #667eea;
    border-radius: 10px;
    padding: 30px;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #666;
  }
  
  .ad-label {
    font-size: 0.75rem;
    color: #999;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 10px;
  }
  
  .ad-placeholder p {
    font-weight: 600;
    color: #667eea;
    margin-bottom: 5px;
  }
  
  .ad-placeholder small {
    font-size: 0.8rem;
    color: #999;
  }
  
  @media (max-width: 768px) {
    .ad-placeholder {
      padding: 20px;
      min-height: 80px;
    }
  }
</style>
